import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles, Tooltip } from '@material-ui/core'
import OpenInNewIcon from '@material-ui/icons/OpenInNew'
import { scoreColor } from '../shared/scoreColor'

const useStyles = makeStyles(() => ({
  card: {
    border: '1px solid var(--color-neutral-200)',
    borderRadius: 'var(--border-radius-sm)',
    padding: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    backgroundColor: 'white'
  },
  head: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  label: {
    fontSize: '10px',
    fontWeight: 700,
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  best: { color: 'var(--color-success-700, #15803d)' },
  worst: { color: 'var(--color-danger-700, #b91c1c)' },
  score: {
    fontSize: '20px',
    fontWeight: 700,
    color: 'var(--color-neutral-900)',
    fontVariantNumeric: 'tabular-nums'
  },
  reasoning: {
    fontSize: 'var(--text-size-xs)',
    color: 'var(--color-neutral-600)',
    lineHeight: 1.5,
    display: '-webkit-box',
    WebkitLineClamp: 3,
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden'
  },
  threadIcon: {
    display: 'inline-flex',
    color: 'var(--color-neutral-400)'
  },
  iconSize: {
    fontSize: 16
  }
}))

function HighlightCard ({ flavor, sample }) {
  const classes = useStyles()
  if (!sample) return null

  const labelClass = flavor === 'best' ? classes.best : classes.worst
  const pct = (sample.weightedScore || 0) * 100

  return (
    <div className={classes.card}>
      <div className={classes.head}>
        <span className={`${classes.label} ${labelClass}`}>
          {flavor === 'best' ? 'Best sample' : 'Worst sample'} {'\u00B7'} #{sample.sampleIndex}
        </span>
        {sample.threadId && (
          <Tooltip title='Open assistant thread' arrow>
            <a
              href={`/denali-ai/chat/${sample.threadId}`}
              target='_blank'
              rel='noreferrer'
              className={classes.threadIcon}
            >
              <OpenInNewIcon className={classes.iconSize} />
            </a>
          </Tooltip>
        )}
      </div>
      <div className={classes.score} style={{ color: scoreColor(pct) }}>
        {pct.toFixed(1)}%
      </div>
      {sample.judgement?.reasoning && (
        <div className={classes.reasoning}>{sample.judgement.reasoning}</div>
      )}
    </div>
  )
}

HighlightCard.propTypes = {
  flavor: PropTypes.oneOf(['best', 'worst']).isRequired,
  sample: PropTypes.object
}

export default HighlightCard
